import { useState } from "react";
import { Box } from "@mui/material";

// Adapts object-fit to the image's real aspect ratio so both vertical and
// horizontal covers display without awkward cropping:
//  - portrait (noticeably taller than wide) -> "contain" on a soft bg (full image visible)
//  - landscape / square                     -> "cover" (fills the frame)
const SmartImage = ({ src, alt, height, radius = 0, bg = "#EFEAE1", fit: fitProp, sx, imgSx }) => {
  const [autoFit, setAutoFit] = useState("cover");
  const fit = fitProp || autoFit;
  if (!src) return null;
  return (
    <Box
      sx={{
        width: "100%",
        height,
        bgcolor: bg,
        borderRadius: radius,
        overflow: "hidden",
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={(e) => {
          if (fitProp) return;
          const { naturalWidth: w, naturalHeight: h } = e.target;
          if (w && h) setAutoFit(h > w * 1.1 ? "contain" : "cover");
        }}
        sx={{ width: "100%", height: "100%", objectFit: fit, display: "block", ...imgSx }}
      />
    </Box>
  );
};

export default SmartImage;
